export * from './linked-textes-dialog';